import React from 'react'
import classNames from 'classnames'

export type CarouselSlideProps = {
  title?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  [x: string]: any;
};

export const CarouselSlide = React.forwardRef<
  HTMLDivElement,
  CarouselSlideProps
>(
  (
    {
      children,
      className,
      style,

      ...restProps
    },
    ref,
  ) => {

    const slideStyle: React.CSSProperties = { ...style };

    const slideClasses = classNames('fr-carousel-slide', className);

    return (
      <div ref={ref} className={slideClasses} style={slideStyle} {...restProps}>
        {children}
      </div>
    );
  },
);